<template>

  <div>
    <b-modal centered class="picturemodal modal-xl" size="lg" ref="patientgallery" id="patientgallery" v-bind:hide-footer="true"  v-bind:title="patientdata.name+' '+patientdata.surname+' '+$t('GALLERY')">
        <div class="d-flex align-items-end flex-column">
          <div class="links">
            <a class="d-none d-md-inline-block" v-if="(selectedimage.imgSrc)" v-on:click="deleteImage">{{$t('DELETE')}} <img src="../assets/img/icon-trash.svg" alt="" /></a>
            <a class="d-none d-md-inline-block" v-if="(selectedimage.imgSrc)" v-bind:href="selectedimage.imgSrc.replace('_90.', '_1024.')" target="_blank">{{$t('DOWNLOAD')}} <img src="../assets/img/icon-save-blue.svg" alt="" /></a>
            <a v-b-modal="'newimage'">{{$t('ADDNEWPHOTO')}} <img src="../assets/img/cell-camera.svg" alt="" /></a>
          </div>
        </div>
        <div class="row" v-if="patientsgallery.root.length == 0">
          <div class="col-12">{{$t('NOPATIENTPICTURES')}}</div>
        </div>
        <div v-if="patientsgallery.root.length > 0" class="picturecontent">
          <div class="row">
            <div class="col-md-6">
              <div class="picturedesc">
                <span class="pictureby">{{$t('PICTUREBY')}}</span>
                <span>{{selectedimage.name}} {{selectedimage.surname}}</span>
              </div>
              <div class="picturedesc">
                <span class="pictureby">{{$t('DATETIME')}}</span>
                <span>{{selectedimage.updateDateTime}}</span>
              </div>
              <div class="picturedesc">
                <span class="pictureby">{{$t('DESCRIPTION')}}</span>
                <span>{{selectedimage.description}}</span>
              </div>
            </div>
            <div class="col-md-6">
                <div class="arrows">
                    <img src="../assets/img/gallery-arrow-ccw.svg" v-on:click="rotate('left')">
                    <img src="../assets/img/gallery-arrow-cw.svg" v-on:click="rotate('right')">
                </div>
                <img class="img-fluid" style="max-height: 800px;" v-bind:src="(selectedimage.imgSrc) ? selectedimage.imgSrc.replace('_90.', '_1024.')+getRand() : ''">
            </div>
          </div>
          <div class="row">
            <div class="col-12 pictures">
              <div class="subimages">
                <div v-on:click="selectedimage = image" v-for="image in patientsgallery.root">
                  <img class="img-responsive" v-bind:class="(selectedimage.imgSrc == image.imgSrc) ? 'selected' : ''" v-bind:src="image.imgSrc+getRand()">
                </div>
              </div>
            </div>
          </div>
        </div>
    </b-modal>

    <b-modal centered size="lg" ref="newimage" id="newimage" v-bind:ok-title="$t('SAVE')" v-bind:cancel-title="$t('CANCEL')" v-on:ok="saveImage" v-bind:title="$t('NEWIMAGE')">
        <div style="width: 100%; height: 100px; text-align: center;" v-if="saveLoading">
          <icon name="spinner" scale="3" spin></icon>
          <div>{{$t('LOADING')}}</div>
        </div>
        <form method="get" action="" v-if="!saveLoading">
          <div class="row">
            <div class="col-12">
              <div class="form-group" v-bind:class="(formError.description) ? 'has-danger' :''">
                <label>{{ $t('DESCRIPTION')}}</label>
                <input type="text" v-model="formData.description" class="form-control secondary" v-bind:placeholder="$t('DESCRIPTION')">
                <div v-if="formError.description" class="form-control-feedback">{{formError.description}}</div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="form-group" v-bind:class="(formError.imgSrc) ? 'has-danger' :''">
                <label>{{ $t('FILE')}}</label>
                <b-form-file :multiple="true" v-model="formData.imgSrc" v-bind:choose-label="$t('JPGORPNG')"></b-form-file>
                <div v-if="formError.imgSrc" class="form-control-feedback">{{formError.imgSrc}}</div>
              </div>
            </div>
          </div>
          <p class="bg-danger" v-if="savePatientsGalleryResponse.error && savePatientsGalleryResponse.notice">{{savePatientsGalleryResponse.notice}}</p>
          <div class="clearfix"></div>
        </form>
    </b-modal>

  </div>



</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import Vue from 'vue'
import patientsGalleryApi from '@/api/patientsgallery'

export default {
  name: 'PatientsGallery',
  props: {patientId: false},
  data: function()
  {
    return {
      selectedimage: {},
      previousImage: null,
      saveLoading: false,
      patientdata: {name: '', surname: ''},
      formData: {
        id: '',
        patientId: '',
        description: '',
        imgSrc: ''
      },
      formError: {},
      pagination:
      {
        query: '',
        currentPage: 1,
        limit: 20
      }
    };
  },
  methods:
  {
    ...mapActions({
      saveImageInit: 'savePatientsGallery',
      getPatientInit: 'getPatient',
      getPatientsGalleryInit: 'getPatientsGallery',
    }),
    getRand()
    {
        return '?rand='+Math.random();
    },
    getPatient: function()
    {
      var me = this;
      this.getPatientInit({id: me.patientId});
    },
    saveImage: function(bvEvt)
    {
      var me = this;
      bvEvt.preventDefault();
      me.saveLoading = true;
      me.saveImageInit(me.formData);
    },
    getPatientsGallery: function()
    {
      var me = this;
      me.getPatientsGalleryInit(me.getParams);
    },
    deleteImage: function()
    {
      var me = this;
      me.$store.commit('setModalAlert',
      {
        text: me.$i18n.t('AREYOUSHURE'),
        btnAction: function()
        {
          patientsGalleryApi.deletePatientsGallery({id: me.selectedimage.patientGalleryId}, function(data)
          {
            if(data.error && data.error == true) me.$notify.error(data.notice);
            else me.$notify.success(data.notice);
            me.$refs.patientgallery.show()
            me.getPatientsGallery();
          })
        }
      })
    },
    rotate(direction)
    {
        const me = this;
        me.previousImage = me.selectedimage.patientGalleryId;
        patientsGalleryApi.rotateImage({id: me.selectedimage.patientGalleryId, direction: direction}, function(data)
        {
            if(data.error && data.error == true) me.$notify.error(data.notice);
            else me.$notify.success(data.notice);
            me.$refs.patientgallery.show()
            me.getPatientsGallery();
        })
    }
  },
  watch:
  {
    patientsgallery: function(val)
    {
      var me = this;

      if(typeof val.root[0] == 'undefined') me.selectedimage = {};
      else
      {
          if (me.previousImage)
          {
              for (const image of patientsgallery.root)
              {
                  if(image.id == me.previousImage)
                  {
                      me.selectedimage = image;
                      break;
                  }
              }
          }
          else
          {
              me.selectedimage = val.root[0];
          }
      }
    },
    patientId: function(val)
    {
      var me = this;

      if(val != false)
      {
        me.formData.patientId = val;
        me.getPatient();
        me.getPatientsGallery();
      }
    },
    patient: function(val)
    {
      var me = this;
      me.patientdata = val.root;
      me.$refs.patientgallery.show()
    },
    savePatientsGalleryResponse: function(val)
    {
      var me = this;

      me.formError = {};

      me.saveLoading = false;

      if(val.error == true)
      {
        if(typeof val.notice == 'object')
        {
          me.formError = val.notice;
          val.notice = '';
        }
      }
      else
      {
        this.$refs.newimage.hide()
        me.getPatientsGallery();
        me.$refs.patientgallery.show()
      }
    },
    'pagination.query': function()
    {
      var me = this;
      me.getPatientsGallery();
    }
  },
  computed:
  {
    ...mapGetters([
      'modalAlert',
      'patientsgallery',
      'patient',
      'savePatientsGalleryResponse'
    ]),
    getParams: function()
    {
      var me = this;
      var data = Object.assign({}, me.pagination, {});
      data.start = (data.currentPage-1)*data.limit;
      data.patientId = me.patientId;
      return data;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PatientsGallery.vue